import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "../ResourcesLayout.module.css";

/** Covers a mobile double-tap interval without lingering longer than needed. */
const EXPLORE_CLICK_THROUGH_GUARD_MS = 350;

const GUARD_LISTENER_OPTIONS = { capture: true };

let disarmExploreClickThroughGuard = null;

function swallowGuardedPointer(event) {
  event.stopPropagation();
  if (event.cancelable) {
    event.preventDefault();
  }
}

/**
 * Temporarily swallows the next pointer/click at window capture so a mobile
 * double-tap cannot retarget onto a project card after SPA navigation.
 * Lives at module scope because ResourceDemoCTA unmounts on navigate.
 */
function armExploreClickThroughGuard() {
  if (disarmExploreClickThroughGuard) {
    disarmExploreClickThroughGuard();
  }

  window.addEventListener("pointerup", swallowGuardedPointer, GUARD_LISTENER_OPTIONS);
  window.addEventListener("click", swallowGuardedPointer, GUARD_LISTENER_OPTIONS);

  const timeoutId = window.setTimeout(() => {
    if (disarmExploreClickThroughGuard) {
      disarmExploreClickThroughGuard();
    }
  }, EXPLORE_CLICK_THROUGH_GUARD_MS);

  disarmExploreClickThroughGuard = () => {
    window.clearTimeout(timeoutId);
    window.removeEventListener("pointerup", swallowGuardedPointer, GUARD_LISTENER_OPTIONS);
    window.removeEventListener("click", swallowGuardedPointer, GUARD_LISTENER_OPTIONS);
    disarmExploreClickThroughGuard = null;
  };
}

/**
 * ResourceDemoCTA — A reusable call-to-action component for the Resources section.
 * Designed to feel like the natural conclusion of the documentation.
 */
const ResourceDemoCTA = ({
  title,
  description,
  primaryLabel = "Book a Demo",
  secondaryLabel = "Explore Projects",
  secondaryAction = "/projects"
}) => {
  return (
    <div className={styles["docs-demo-cta"]}>
      <h3 className={styles["docs-demo-cta-title"]}>{title}</h3>
      <p className={styles["docs-demo-cta-desc"]}>{description}</p>

      <div className={styles["docs-demo-cta-actions"]}>
        <button
          type="button"
          className={styles["docs-demo-btn-primary"]}
          onClick={() => toast.info("Coming soon — stay tuned!")}
        >
          {primaryLabel}
        </button>
        {secondaryLabel && (
          <Link
            to={secondaryAction}
            className={styles["docs-demo-btn-secondary"]}
            onClick={armExploreClickThroughGuard}
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ResourceDemoCTA;
